"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WhatsappButton = exports.whatsappShareAction = void 0;

var _sharing_helper = require("../../helpers/sharing_helper");

var _icons = require("../../assets/icons");

var _base = require("./base");

var whatsappShareAction = function whatsappShareAction(_ref) {
  var shareUrl = _ref.shareUrl,
      teaser = _ref.teaser,
      utmParams = _ref.utmParams;
  return window.open("https://".concat((0, _sharing_helper.isMobileOrTablet)() ? 'api' : 'web', ".whatsapp.com/send?text=").concat((0, _sharing_helper.encodedShareURL)("".concat(teaser ? teaser + ' ' : '').concat(shareUrl), utmParams)));
};

exports.whatsappShareAction = whatsappShareAction;
var WhatsappButton = (0, _base.buildShareButtonComponent)({
  action: whatsappShareAction,
  ariaLabel: 'WhatsApp',
  color: '#01E677',
  icon: _icons.WhatsappIcon
});
exports.WhatsappButton = WhatsappButton;